module.exports = __webpack_public_path__ + "static/media/brands-04-papa-johns@2x.ef83ce29.png";